module.exports = "/_next/static/images/Cover@2x-517efd5b2c49d4e26760d5cb4d7b3a49.webp";